import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromTheme from '../reducers/theme.reducer';

export const getThemeState = createSelector(fromFeature.getThemeState, (state: fromTheme.ThemeState) => state);

export const getTheme = createSelector(getThemeState, (state: fromTheme.ThemeState) => state.theme);
